import { render } from "./AnimationSettings.vue?vue&type=template&id=ccb1d04a&scoped=true"
import script from "./AnimationSettings.vue?vue&type=script&lang=js"
export * from "./AnimationSettings.vue?vue&type=script&lang=js"

import "./AnimationSettings.vue?vue&type=style&index=0&id=ccb1d04a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb1d04a"]])

export default __exports__